import {Check} from "@sparkware/app-utils";
import {IServiceFactoryExtended} from "../service-factory-extended.interface";
import {InGamePromotionPrizes} from "./in-game-promotion-prizes";

export class InGamePromotionPrizesProvider {
    private promotionPrizes: Record<number, InGamePromotionPrizes> = {};

    constructor(private services: IServiceFactoryExtended) {}

    public getPrizesWrapper(promotionId: number) {
        let prizesObj = this.promotionPrizes[promotionId];
        if (Check.isNullOrUndefined(prizesObj)) {
            prizesObj = new InGamePromotionPrizes(promotionId, this.services);
            this.promotionPrizes[promotionId] = prizesObj;
        }
        return prizesObj;
    }
}
